import type {
  PlaybookCondition,
  PlaybookHasResultCondition,
} from "@repo/app-types/entities/filterConditions";

export function checkIsPlaybookHasResultCondition(
  condition: PlaybookCondition,
): condition is PlaybookHasResultCondition {
  return "kind" in condition && condition.kind === "has_result";
}

/**
 * Drop the has-result conditions, leaving the criterion/section conditions the
 * user picked. The has-result condition is a page default controlled by
 * "Include calls without grades" rather than something the user added, so
 * comparisons that ask "did the user narrow the results?" run over this.
 */
export function stripPlaybookHasResultConditions(
  conditions: readonly PlaybookCondition[],
): readonly PlaybookCondition[] {
  return conditions.filter(
    (condition) => !checkIsPlaybookHasResultCondition(condition),
  );
}
